var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepItem2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Numbers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.0654,12 C1.0654,5.925 5.9894,1 12.0654,1 C18.1394,1 23.0654,5.925 23.0654,12 C23.0654,18.075 18.1404,23 12.0654,23 C5.9904,23 1.0654,18.075 1.0654,12 Z M3.0654,12 C3.0654,16.9704545 7.09494545,21 12.0654,21 C17.0358545,21 21.0654,16.9704545 21.0654,12 C21.0654,7.02954545 17.0350364,3 12.0654,3 C7.09412727,3 3.0654,7.02954545 3.0654,12 Z M15.7035,14.589 L15.7035,16.5 L8.7615,16.5 L8.7485,14.927 L12.0635,11.521 C12.3235013,11.252332 12.5358325,10.983668 12.7005,10.715 C12.8651675,10.446332 12.9475,10.2166676 12.9475,10.026 C12.9475,9.77466541 12.8565009,9.581834 12.6745,9.4475 C12.4924991,9.31316599 12.236835,9.246 11.9075,9.246 C11.5434982,9.246 11.1383356,9.34783231 10.692,9.5515 C10.2456644,9.75516768 9.81450208,10.0389982 9.3985,10.403 L8.4885,8.648 C9.74517295,7.73799545 11.0061603,7.283 12.2715,7.283 C12.8781697,7.283 13.4219976,7.38266567 13.903,7.582 C14.3840024,7.78133433 14.7609986,8.06299818 15.034,8.427 C15.3070014,8.79100182 15.4435,9.20699766 15.4435,9.675 C15.4435,10.1430023 15.2896682,10.6261642 14.982,11.1245 C14.6743318,11.6228358 14.2388361,12.1536638 13.6755,12.717 L11.8165,14.589 L15.7035,14.589 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Numbers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-400",
    mask: "url(#mask-2)",
    fill: "#848484"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepItem2);
export default __webpack_public_path__ + "static/media/step-item-2.f0b752d437ee529082a4749cc6fb42bc.svg";
export { ForwardRef as ReactComponent };